import React from "react"

import Layout from "../components/global/Layout"
import Hero from "../components/block/Hero"
import MediaFeatureSVG from "../components/block/MediaFeatureSVG"
import CTA from "../components/block/CTA"
import SEO from "../components/global/SEO"

import Ecommerce from "../images/illustration/ecommerce.svg"
import Hotspots from "../images/illustration/hotspots.svg"
import MiroUsers from "../images/illustration/miro-users.svg"
import Opinions from "../images/illustration/opinions.svg"
import TaskCheck from "../images/illustration/task-check.svg"

export default function OurUserTestingPage() {
  return (
    <div>
      <Layout>
        <SEO
          title="Our expertise goes well beyond user testing"
          description="User-centred design and user experience consultancy.
"
        />
        <Hero
          title="Our expertise goes well beyond user testing"
          content="User-centred design and user experience consultancy.
"
        />
        <MediaFeatureSVG src={Hotspots}>
          <h2>Rapid prototyping and testing </h2>
          <p>Got a new product or new feature in mind?</p>
          <p>
            Learn fast, learn early, reduce your risk and maximise your chances
            of success.
          </p>
          <p>
            We can design and user test a high-fidelity, clickable prototype
            that can be refined and optimised before you spend a penny on your
            technical build.
          </p>
        </MediaFeatureSVG>
        <MediaFeatureSVG
          src={Opinions}
          backgroundColorOverride={props => props.theme.shade[90]}
          reverse
        >
          <h2>User-centred design and build</h2>
          <p>Looking for a user-centred design and build?</p>
          <p>
            We team up with select UX designers and developers who are skilled
            at working with our user insights.
          </p>
          <p>
            We have designed and built engaging, high performing Saas websites,
            online applications and e-commerce solutions.{" "}
          </p>
        </MediaFeatureSVG>
        <MediaFeatureSVG src={MiroUsers}>
          <h2>User experience design</h2>
          <p>
            After conducting your user testing, we are deeply immersed in your
            solution and highly knowledgeable about your users, their needs and
            how to optimise your journeys.
          </p>
          <p>
            We can work with you and our trusted UX designers to implement the
            findings of our research and deliver to you an optimised user
            experience.
          </p>
        </MediaFeatureSVG>
        <MediaFeatureSVG
          src={TaskCheck}
          backgroundColorOverride={props => props.theme.shade[90]}
          reverse
        >
          <h2>Expert reviews/ cognitive walkthroughs </h2>
          <p>
            Where user testing is not possible, an expert walkthrough is the
            next best thing.
          </p>
          <p>
            Acting as a typical user, we will review your user journeys. Using
            our experience and knowledge of user behaviour we will highlight
            where confusion, friction or frustration might arise and recommend
            where and how to improve your user experience.
          </p>
        </MediaFeatureSVG>
        <MediaFeatureSVG src={Ecommerce}>
          <h2>E-commerce audits</h2>
          <p>
            Having worked with FTSE100 and SME e-commerce businesses, we have
            developed a deep understanding as to what makes for a
            high-converting shopping experience.
          </p>
          <p>
            Our e-commerce audit includes a check against over 250 factors that
            influence the performance of an online shop. Your report will
            identify where and how to improve the effectiveness of your website.
          </p>
        </MediaFeatureSVG>
        <CTA
          backgroundColorOverride={props => props.theme.shade[90]}
          postContent="Feel free to get in touch for a completely no-obligation discussion about how we might be able to help."
          buttonText="Get in touch"
          buttonLink="/contact/"
        />
      </Layout>
    </div>
  )
}
